<div class="text-center">
	<div>
		<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
			<circle cx="34" cy="34" fill="#1EB12D" fill-opacity="0.1" r="34" />
			<circle cx="32.875" cy="32.875" fill="white" r="16.875" />
			<path
				d="M34 56.5C21.5792 56.4864 11.5136 46.4208 11.5 34V33.55C11.7473 21.1852 21.9278 11.3379 34.294 11.502C46.6602 11.6661 56.5758 21.78 56.495 34.147C56.4142 46.5141 46.3673 56.4976 34 56.5ZM25.2603 34.6592C24.3829 33.7852 22.9635 33.7865 22.0878 34.6623C21.2109 35.5392 21.2109 36.9609 22.0878 37.8378L27.0714 42.8215C28.4127 44.1627 30.5873 44.1627 31.9286 42.8215L45.9137 28.8363C46.7907 27.9593 46.7932 26.5383 45.9194 25.6582C45.0411 24.7737 43.6114 24.7712 42.73 25.6526L30.0183 38.3643C29.7319 38.6507 29.2677 38.6511 28.9807 38.3653L25.2603 34.6592Z"
				fill="#1EB12D" />
		</svg>
	</div>
	<div class="m-t-16">
		<div class="success-title">
			{{title}}
		</div>
	</div>
	<div class="m-t-6">
		<div class="success-des">
			{{description}}
		</div>
	</div>


	<div *ngIf="additionalResponses?.length" class="m-t-24">
		<div class="additional-info-container">
			<div *ngFor="let item of additionalResponses" class="m-t-8" nz-row nzAlign="middle"
				nzJustify="space-between">
				<div>
					<div class="additional-info-title">{{item?.key}}:</div>
					<div class="additional-info-text m-t-2">{{item?.value}}</div>
				</div>
				<div>
					<div (click)="copyAdditionalInfo(item?.value)" *ngIf="item?.key?.toLowerCase() === 'token'" nz-row
						nzAlign="middle" style="position: relative;top:.7em">
						<div style="position:relative;top:2px">
							<svg fill="none" height="25" viewBox="0 0 24 25" width="24"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M14 8.80469H4C2.897 8.80469 2 9.70169 2 10.8047V20.8047C2 21.9077 2.897 22.8047 4 22.8047H14C15.103 22.8047 16 21.9077 16 20.8047V10.8047C16 9.70169 15.103 8.80469 14 8.80469Z"
									fill="#0361F0" />
								<path
									d="M20 2.80469H10C9.46957 2.80469 8.96086 3.0154 8.58579 3.39047C8.21071 3.76555 8 4.27425 8 4.80469V6.80469H16C16.5304 6.80469 17.0391 7.0154 17.4142 7.39047C17.7893 7.76555 18 8.27425 18 8.80469V16.8047H20C20.5304 16.8047 21.0391 16.594 21.4142 16.2189C21.7893 15.8438 22 15.3351 22 14.8047V4.80469C22 4.27425 21.7893 3.76555 21.4142 3.39047C21.0391 3.0154 20.5304 2.80469 20 2.80469Z"
									fill="#0361F0" />
							</svg>
						</div>
						<div class="copy-icon m-l-8">
							<span> Copy</span> <span (mouseout)="setCopied()" *ngIf="isCopied" class="copy-icon m-l-2"
								style="font-size:9px!important;">Copied!
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


	<div class="m-t-16">
		<div class="success-divider {{useFullButton?'success-divider-adjustment':''}}">
		</div>
	</div>
	<div *ngIf="!useFullButton" class="m-t-16">
		<div nz-row nzAlign="middle" nzJustify="space-between">
			<div></div>
			<div>
				<button (click)="cancelModal()" class="btn btn-primary button-size-157" nz-button>
					Close
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="useFullButton" class="m-t-16">
		<div>
			<button (click)="cancelModal()"
			class="btn full-btn" nz-button>
			{{btnText || 'Close'}}
			</button>
		</div>
	</div>
</div>
